import * as React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({
    disabledArea: {
        position: "absolute",
        background: "#f3f6fc",
        width: "100%",
        height: "100%",
        zIndex: 100,
        opacity: 0.6
    }
});

type Props = WithStyles;

const disableArea = (props: Props) =>
    <div className={props.classes.disabledArea} />;

export default withStyles(style)(disableArea);
